"use client"

import React from 'react'
import Link from "next/link";
import Image from "next/image";
import parse from "html-react-parser";
import { IPageContent } from '@/types/pageContent.types';
import TransitionLink from '../TransitionLink';
import styles from './stylesV15.module.scss'


export type IFooterViewProps = {
  footerData: IPageContent["footerModelV15"]["footer"];
};

const FooterViewV15: React.FC<IFooterViewProps> = ({ footerData }) => {
  // console.log("footerData", footerData);
  const primaryLogo = footerData.gallery?.[0];
  const hidonixLogo = footerData.gallery?.[1];
  
  return (
    <div className={styles.footer}>
      <div className={`${styles.maxWidthContainer} maxWidthContainer`}>

        {primaryLogo ? (
          <TransitionLink href={'/'}>
            <Image
              className={styles.logoImage}
              src={primaryLogo.url}
              alt={primaryLogo.alt}
              width="150"
              height="50"
            />
          </TransitionLink>
        ) : null}

        <div className={styles.colsContainer}>
          <div className={styles.leftCol}>
            <h2>{parse(footerData.heading)}</h2>
            <p>{parse(footerData.body)}</p>
          </div>
          <div className={styles.rightCol}>
            {
              footerData.contactsMediaCareersHeadquarters.map((item, index) => (
                <div className={styles.contactItem} key={index}>
                  <h3>{parse(item.heading)}</h3>
                  <p>{parse(item.body)}</p>
                </div>
              ))
            }
          </div>
        </div>

        <div className={styles.btnsContainer}>
          <div className={styles.disclaimerContainer}>
            {/* <a href="https://www.iubenda.com/privacy-policy/34502914">
              <p>Privacy Policy</p>
            </a>
            
            <span>|</span>
            
            <a href="https://www.iubenda.com/privacy-policy/34502914/cookie-policy">
              <p>Cookie Policy</p>
            </a>
            
            <span>|</span>

            <a href="/vdp">
              <p>Vulnerability Disclosure Policy</p>
            </a> */}

            <a href="https://www.iubenda.com/privacy-policy/73634685">
              <p>Privacy Policy</p>
            </a>
            
            <span>|</span>
            
            <a href="https://www.iubenda.com/privacy-policy/73634685/cookie-policy">
              <p>Cookie Policy</p>
            </a>

            <span>|</span>

            <a href="https://www.iubenda.com/terms-and-conditions/73634685">
              <p>Terms and Conditions</p>
            </a>

            {/* <span>|</span> */}

            {/* <a href="/vdp">
              <p>Vulnerability Disclosure Policy</p>
            </a> */}
            
            {/* <span>|</span> */}
            
            {/* <a href="/press-kit">
              <p>Press Kit</p>
            </a>     */}
          </div>

          {/* {'gallery' in footerData && (
            <Image
              className={styles.heroImage}
              src={footerData.gallery[0].url}
              alt={footerData.gallery[0].alt}
              width="200"
              height="200"
            />
          )} */}
          {/* Powered by Hidonix Industries */}
          {hidonixLogo ? (
            <a
              className={styles.logoHidonixIndustriesContainer}
              href="https://hidonix.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                src={hidonixLogo.url}
                alt={hidonixLogo.alt}
                width="200"
                height="48"
              />
              <p>{parse(footerData.logoDesc)}</p>
            </a>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default FooterViewV15
